import { render, staticRenderFns } from "./FaqLand.vue?vue&type=template&id=f3c311b6&"
import script from "./FaqLand.vue?vue&type=script&lang=js&"
export * from "./FaqLand.vue?vue&type=script&lang=js&"
import style0 from "./FaqLand.vue?vue&type=style&index=0&id=f3c311b6&prod&lang=scss&"
import style1 from "./FaqLand.vue?vue&type=style&index=1&id=f3c311b6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports